import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { IncludesSection } from './components/IncludesSection';
import { BenefitsSection } from './components/BenefitsSection';
import { TransformationSection } from './components/TransformationSection';
import { ForWhoSection } from './components/ForWhoSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    if (window.fbq) return;
    const n: any = window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    window.fbq('init', '3025509647634594');
    window.fbq('track', 'PageView');
  }, []);
  return <main className="min-h-screen bg-cream font-sans selection:bg-gold/30 selection:text-navy" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <SolutionSection data-id="element-3" />
      <IncludesSection data-id="element-4" />
      <BenefitsSection data-id="element-5" />
      <TransformationSection data-id="element-6" />
      <ForWhoSection data-id="element-7" />
      <CTASection data-id="element-8" />
      <Footer data-id="element-9" />
    </main>;
}